import mergeState from './mergeState'

export const mergeRequestAction = (
  state,
  { payload: { request, options: actionOptions = {} }, options = {} },
  { url }: any = {},
) => {
  // @ts-expect-error TS(2339) FIXME: Property 'url' does not exist on type '{}'.
  const urlToUse = url ?? options.url ?? actionOptions.url ?? request.url

  return mergeState(state, {
    [urlToUse]: {
      // @ts-expect-error TS(2339) FIXME: Property 'ignoreResponse' does not exist on type '... Remove this comment to see the full error message
      fetching: !options.ignoreResponse,
    },
  })
}

export default mergeRequestAction
